import { associeradListVy } from '../../_Common/Components/BusinessCollectionComponents/associeradListVy';
import { IObjektVy } from '../../../../Types/ObjektVy';
import { standardVy } from '../../../../Utils/ObjektVyUtils';

const standard: IObjektVy = standardVy([
  associeradListVy('Bokfverifikationer', {
    customDefaultColumns: [
      { attributeDef: 'VER_NR', caption: 'Vernr' },
      { attributeDef: 'DATUM', caption: 'Bokf.datum' },
      { attributeDef: 'TEXT', caption: 'Text' },
      { attributeDef: 'Summa_Debet', caption: 'Debet' },
      { attributeDef: 'Summa_Kredit', caption: 'Kredit' },
    ],
  }),
]);

export const Bokfjournalvyer: IObjektVy[] = [standard];
